import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/Census/emergency`;

/**
 * Obtiene el listado de visitas a sala de emergencias (ER).
 *
 * El scope por rol lo aplica el backend (Admin ve todos los locations,
 * otros roles solo su location primario).
 *
 * @param {Object} [filters]
 * @param {string} [filters.cipId]        - CIP específico.
 * @param {number} [filters.locationId]   - Center (dentro del scope permitido).
 * @param {string} [filters.searchName]   - LIKE sobre nombre completo.
 * @param {string} [filters.dateOfBirth]  - DOB exacto (YYYY-MM-DD).
 * @param {number} [filters.minLace]      - LACE+ mínimo. LACE+ solo presente en ~5% de los ER.
 * @param {string} [filters.facilityName] - LIKE sobre facility. Un paciente puede tener visitas en múltiples ER.
 * @param {string} [filters.dateFrom]     - Admit date ≥ (YYYY-MM-DD).
 * @param {string} [filters.dateTo]       - Admit date ≤ (YYYY-MM-DD).
 *
 * Ejemplo de llamada:
 * GET /api/Census/emergency?facilityName=Gulf
 *
 * Respuesta exitosa (200):
 * [
 *   {
 *     "emergencyEventId": 315,
 *     "cipId": "53750191573",
 *     "fullName": "SENDA, MARIAN J",
 *     "dateOfBirth": "1954-10-04T00:00:00",
 *     "gender": "F",
 *     "phoneNumber": "(305) 869-2626",
 *     "mobileNumber": null,
 *     "memberEmail": null,
 *     "admitDate": "2026-04-23T00:00:00",
 *     "facilityName": "Gulf coast Medical Center",
 *     "placeOfService": "Emergency Room–Hospital",
 *     "dischargeDisposition": null,
 *     "diagnoses": "R60.0",
 *     "laceScore": null,
 *     "behavioralHealth": false,
 *     "attendingPhysicianName": "MCILWAINE,JESSE L",
 *     "attendingPhysicianSpec": "HOSPITALIST",
 *     "facilityPhone": "2393430434",
 *     "facilityAddress": "13681 DOCTORS WAY",
 *     "facilityCity": "FORT MYERS",
 *     "facilityState": "FLORIDA",
 *     "lastSeen": "2026-04-23T00:00:00",
 *     "locationId": 4,
 *     "medicalCenter": "Immokalee",
 *     "locationAddress": "1502 LAKE TRAFFORD RD, Immokalee, FL - 34142-2618, Collier"
 *   }
 * ]
 *
 * No hay `dischargeDate` ni `admitDays` — la visita a ER se modela como un único
 * momento (`admitDate`).
 *
 * Posibles errores:
 * 401 Sin token o token inválido.
 * 500 Excepción en el SP o pipeline (el repo retorna lista vacía para no romper el front).
 */
export const getEmergencyPatients = async (filters = {}) => {
  try {
    const params = buildParams(filters);
    const response = await axios.get(API_URL, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching emergency patients:", error);
    throw error;
  }
};

const buildParams = (filters) => {
  const params = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    params[key] = value;
  });
  return params;
};
